/**
 * Add margin to container
 */
import React, { RefObject, SetStateAction } from 'react';

let noOffset;

export default function adjustMainContainerOffset(
  headerRef: RefObject<any>,
  containerId: string,
  setOffset?: React.Dispatch<SetStateAction<number>>,
  disableOffsetAdjustment?: boolean,
) {
  const headerEl = headerRef?.current;
  const containerEl = document.getElementById(containerId);

  noOffset = disableOffsetAdjustment;

  // Handle window resize, apply padding to container
  const onWindowResize = () => {
    // Check if main container and visible header present
    if (containerEl && headerEl?.style?.display !== 'none') {
      const offset = headerEl ? (noOffset ? 0 : headerEl.offsetHeight) : 0;

      if (setOffset) {
        setOffset(offset);
      }

      containerEl.style.paddingTop = offset + 'px';
    }
  };

  // Listen to window resize event to check if mobile view needs to be applied
  window.removeEventListener('resize', onWindowResize);
  window.addEventListener('resize', onWindowResize);

  // Initial load
  onWindowResize();

  // Cleanup
  return function cleanup() {
    window.removeEventListener('resize', onWindowResize);
  };
}
